import type { BadgeType, MainCategoriesType, ShortGameZipType } from '@/types'
import { shuffle } from '@/utils/helpers'

const PURCHASE_DISABLED_TOP_GAMES_HRUS: Record<string, true> = {
    'piece-of-cake-merge--bake': true,
    'vega-mix-2-adventure': true,
    'chess-online-multiplayer': true,
    'mr-racer-car-racing': true,
}

type TopGame = {
    hru: string
    title: string
    likes: string
    icon: string
    color: string
    badges?: BadgeType[]
}

export const topGames: TopGame[] = [
    {
        hru: 'age-of-tanks-warriors-td-war',
        title: 'Age of Tanks Warriors: TD War',
        likes: '26k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-106324/icon/99eb1cddd7885f2031a9d560b5e366847b85408438ff4e3908ee9060d611f7d2?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'bubble-blast',
        title: 'Bubble Blast',
        likes: '11k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-72/icon/f90c9f98386558445fe7943cdc25fb32e4ff996f2770e2103f21fc6af5663dcc?width=218',
        color: '#ff1f00',
        badges: ['top'],
    },
    {
        hru: 'chess-online-multiplayer',
        title: 'Chess Online Multiplayer',
        likes: '6k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-111579/icon/aa413f10d289fb589db39171607a7448af79ebb94b3b653cd342e941138f3f78?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'deadly-descent',
        title: 'Deadly Descent',
        likes: '7k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-44/icon/46bc7f6a80a55b33244d81f0f6a660a619efa33ebdaec06e2299a0e2d40785e4?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'fruit-merge-playgama',
        title: 'Fruit Merge: Juicy Drop Game',
        likes: '3k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-59/icon/aa2a1ccbb0b55e29f3fbd14c00af57b0e373400b66efbd6ccd707e56d19041c6?width=218',
        color: '#1aff00',
        badges: ['top'],
    },
    {
        hru: 'gangster-island-crime-city',
        title: 'Gangsta Island: Crime City',
        likes: '13k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-92176/icon/8eac704386b58566b1247a75aa3276d671c0b371f71d7e40c1b7b0e63f9e1a4c?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'good-sort-master',
        title: 'Good Sort Master: Triple Match',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-46/icon/c0a46a5e5ca0f818973da4fe340b68b9ab6d9cce73ea4babad9e167ef9393bd0?width=218',
        color: '#d07ffe',
        badges: ['top'],
    },
    {
        hru: 'hidden-object-my-hotel',
        title: 'Hidden Object: My Hotel',
        likes: '8k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-109352/icon/a6b9915886a795de6a12ea045ae44350672228c3efe5081d717873e61255c837?width=218',
        color: '#b03ff1',
    },
    {
        hru: 'millionaire-life',
        title: 'Millionaire Life',
        likes: '18k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-111970/icon/426007ed1dcaa280e411e1aacfbc836ec0572b3f27ac6ab874db3d94267f40a7?width=218',
        color: '#e7572b',
    },
    {
        hru: 'mr-racer-car-racing',
        title: 'MR RACER - Car Racing',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-90490/icon/1e73c6b9b06c3586f6c0199519bfdbf7c8a5b8c2da8fbb4a225a9d4d287f6cc2?width=218',
        color: '#3fe1f1',
        badges: ['top'],
    },
    {
        hru: 'my-town-home-family-playhouse',
        title: 'My Town Home: Family Playhouse',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-86391/icon/9bc47713edeb7b4dba4a6cb5b45f9292cd98dd220aa9189824cbf1dc029d48b7?width=218',
        color: '#c8ff00',
        badges: ['top'],
    },
    {
        hru: 'piece-of-cake-merge--bake',
        title: 'Piece of Cake: Merge & Bake',
        likes: '5k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-97426/icon/6067d1465ed11aebb966da2c2441cff5d9760a9c34f6ceb0fa504bca50799963?width=218',
        color: '#fff200',
        badges: ['top'],
    },
    {
        hru: 'snake-2048-64be-1',
        title: 'Snake 2048',
        likes: '3k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-86383/icon/67bcda82b14998c7978bbcca1e2ee5ea5fb5574ab5e009b23c4a2787bf34ac17?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'speed-per-click-obby',
        title: 'Speed per Click: Obby',
        likes: '3k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-112301/icon/c47b3f94b9a50b3a5f182e345d30ced7a57dfb617af9e5ca29c6ce2f0246078b?width=218',
        color: '#3fe1f1',
    },
    {
        hru: 'tb-world',
        title: 'TB World',
        likes: '15k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-90498/icon/3a5f27d96c92a7382fbfd3a07c58fdb40b94cb58406ca8cfc4a178a0e7fa87fe?width=218',
        color: '#1aff00',
        badges: ['hot'],
    },
    {
        hru: 'vega-mix-2-adventure',
        title: 'Vega Mix 2: Adventure',
        likes: '10k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-112864/icon/4ff6ded33f9f4f9f1c4dc9926e34121c7400a52408f4bec7d0a0f9568f4cc6ce?width=218',
        color: '#3fe1f1',
        badges: ['top'],
    },
    {
        hru: 'hero-defense-king',
        title: 'Hero Defense King',
        likes: '2k',
        icon: 'https://static.playgama.com/p-img/pg/backfill/game-118083/icon/11d62a3eb46332df57723414f8f489a0868eed97fb40f49dc37c8cf6437d0c9c?width=218',
        color: '#ff6b00',
        badges: ['top'],
    },
]

function zipTopGames(game: TopGame): ShortGameZipType {
    return [game.hru, '', '', '', '', '', false, undefined, [], 'playgama', undefined]
}

export const createPlaygamaTopCategory = (isPurchaseEnabled: boolean) => {
    const filteredGames = isPurchaseEnabled
        ? topGames
        : topGames.filter((game) => !PURCHASE_DISABLED_TOP_GAMES_HRUS[game.hru])

    return {
        id: 'top_playgama' as MainCategoriesType,
        title: 'Playgama Top',
        location: {
            name: 'category',
            params: {
                hru: 'top_playgama',
            },
        },
        games: shuffle(filteredGames.map(zipTopGames)),
    }
}
